import { CircularProgress } from '@material-ui/core';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import React, { useEffect } from 'react';

const PieChartClasificacion = props => {
	const { data, isLoading } = props;
	const billPymes = data.totalBillVentaPyme;
	const billCorp = data.totalBillVentaCorp;

	//TODO: Arreglar esto para funcionar con el isLoading!
	useEffect(() => {
		const updateHook = async () => {};
		updateHook();
	}, []);

	const options = {
		chart: {
			type: 'pie',
		},
		title: {
			text: 'Ingresos por Clasificacion',
		},
		tooltip: {
			pointFormat: 'value: {point.y}',
		},
		plotOptions: {
			pie: {
				dataLabels: {
					enabled: true,
					format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
				},
			},
		},
		series: [
			{
				name: 'Ingresos',
				colorByPoint: true,
				data: [
					{
						name: 'Pymes',
						y: billPymes,
						liced: true,
						selected: true,
					},
					{
						name: 'Corps',
						y: billCorp,
					},
				],
			},
		],
	};

	return (
		<React.Fragment>
			{isLoading ? <CircularProgress /> : <HighchartsReact highcharts={Highcharts} options={options} />}
		</React.Fragment>
	);
};

export default React.memo(PieChartClasificacion);
